import script from "./NoticiaEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaEditorView.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaEditorView.vue?vue&type=style&index=0&id=27baa73c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27baa73c"]])

export default __exports__